var form = $('#edit_user');
if (form.length > 0) {
  require.ensure('../sections/registrations/edit', function(require) {
    var EditUserForm = require('../sections/registrations/edit');
    new EditUserForm(form);
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/edit_user_form.initializer.js